export class SubJobSoIdRequest{
    soId:number[];
    constructor(soId:number[]){
        this.soId = soId;
    }
}